module.exports = __webpack_public_path__ + "img/source-sans-pro-v21-latin-700.660ce2bb.svg";